module.exports = __webpack_public_path__ + "media/images/icons/vendors/suits-9f9bd29f906b8b08802f90885243c853.png";